import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { DepartureTypeNgrx } from './departure-type.model';

export enum DepartureTypeActionTypes {
  LoadDepartureTypes = '[DepartureType] Load DepartureTypes',
  AddDepartureType = '[DepartureType] Add DepartureType',
  UpsertDepartureType = '[DepartureType] Upsert DepartureType',
  AddDepartureTypes = '[DepartureType] Add DepartureTypes',
  UpsertDepartureTypes = '[DepartureType] Upsert DepartureTypes',
  UpdateDepartureType = '[DepartureType] Update DepartureType',
  UpdateDepartureTypes = '[DepartureType] Update DepartureTypes',
  DeleteDepartureType = '[DepartureType] Delete DepartureType',
  DeleteDepartureTypes = '[DepartureType] Delete DepartureTypes',
  ClearDepartureTypes = '[DepartureType] Clear DepartureTypes',
}

export class LoadDepartureTypes implements Action {
  public readonly type = DepartureTypeActionTypes.LoadDepartureTypes;

  constructor(public payload: { departureTypes: DepartureTypeNgrx[] }) {}
}

export class AddDepartureType implements Action {
  public readonly type = DepartureTypeActionTypes.AddDepartureType;

  constructor(public payload: { departureType: DepartureTypeNgrx }) {}
}

export class UpsertDepartureType implements Action {
  public readonly type = DepartureTypeActionTypes.UpsertDepartureType;

  constructor(public payload: { departureType: DepartureTypeNgrx }) {}
}

export class AddDepartureTypes implements Action {
  public readonly type = DepartureTypeActionTypes.AddDepartureTypes;

  constructor(public payload: { departureTypes: DepartureTypeNgrx[] }) {}
}

export class UpsertDepartureTypes implements Action {
  public readonly type = DepartureTypeActionTypes.UpsertDepartureTypes;

  constructor(public payload: { departureTypes: DepartureTypeNgrx[] }) {}
}

export class UpdateDepartureType implements Action {
  public readonly type = DepartureTypeActionTypes.UpdateDepartureType;

  constructor(public payload: { departureType: Update<DepartureTypeNgrx> }) {}
}

export class UpdateDepartureTypes implements Action {
  public readonly type = DepartureTypeActionTypes.UpdateDepartureTypes;

  constructor(public payload: { departureTypes: Update<DepartureTypeNgrx>[] }) {}
}

export class DeleteDepartureType implements Action {
  public readonly type = DepartureTypeActionTypes.DeleteDepartureType;

  constructor(public payload: { id: string }) {}
}

export class DeleteDepartureTypes implements Action {
  public readonly type = DepartureTypeActionTypes.DeleteDepartureTypes;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearDepartureTypes implements Action {
  public readonly type = DepartureTypeActionTypes.ClearDepartureTypes;
}

export type DepartureTypeActions =
  | LoadDepartureTypes
  | AddDepartureType
  | UpsertDepartureType
  | AddDepartureTypes
  | UpsertDepartureTypes
  | UpdateDepartureType
  | UpdateDepartureTypes
  | DeleteDepartureType
  | DeleteDepartureTypes
  | ClearDepartureTypes;
